/**
 * Dashboard stat card combining Card + MetricDisplay + SparkChart.
 */

import type { Trend } from "@/lib/chart-helpers";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { MetricDisplay } from "@/components/monitoring/MetricDisplay";
import { SparkChart } from "@/components/monitoring/SparkChart";
import { cn } from "@/lib/utils";

type StatCardProps = {
  title: string;
  value: string;
  trend?: Trend;
  sparkData?: { value: number }[];
  sparkColor?: string;
  className?: string;
};

export function StatCard({ title, value, trend, sparkData, sparkColor, className }: StatCardProps) {
  return (
    <Card className={cn("overflow-hidden", className)}>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium text-muted-foreground">{title}</CardTitle>
      </CardHeader>
      <CardContent className="flex items-end justify-between gap-4">
        <MetricDisplay label="" value={value} trend={trend} />
        {sparkData && sparkData.length > 1 && (
          <SparkChart data={sparkData} color={sparkColor} height={36} className="w-24" />
        )}
      </CardContent>
    </Card>
  );
}
